import { render, staticRenderFns } from "./ClientUser.vue?vue&type=template&id=cfc87b7a"
import script from "./ClientUser.vue?vue&type=script&lang=js"
export * from "./ClientUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports